export const uniqueColorImageUrl =
  'https://d22oza65jfl1r0.cloudfront.net/b9c0bb3f-f917-491c-ae85-60619ced47ab-Captura_de tela 2024-02-27 122255.jpeg';
